// src/services/firmaInfo.js
//
// Kullanıcı hesabından firma + proje sorumlusu (müellif) bilgilerini okur.
// Kaynak: Ayarlar sayfasının localStorage kayıtları
//   - projabze_company_<uid> : { name, taxNo, taxOffice, address, city, district, phone, ... }
//   - projabze_author_<uid>  : { title, fullName, diplomaNo, chamberNo, vergiNo, vergiDairesi, phone, ... }
// uid = projabze_user.id || projabze_user.email
//
// CAD Oluşturucu 'Marka' modu + generateMarka bu veriyi kullanır (native marka alanı).

function getUid() {
  try {
    const u = JSON.parse(localStorage.getItem('projabze_user') || 'null');
    return u ? (u.id || u.email) : null;
  } catch { return null; }
}

function readJson(key) {
  try { return JSON.parse(localStorage.getItem(key) || '{}') || {}; }
  catch { return {}; }
}

/**
 * Hesaptaki firma + sorumlu bilgisini marka veri modeline çevirir.
 * Alan yoksa boş string döner (kullanıcı CAD Oluşturucu'da doldurabilir/düzenleyebilir).
 * @returns {{ firma: object, sorumlu: object }}
 */
export function getFirmaInfo() {
  const uid = getUid();
  const company = uid ? readJson(`projabze_company_${uid}`) : {};
  const author = uid ? readJson(`projabze_author_${uid}`) : {};

  const adres = [company.address, company.district, company.city]
    .map(s => (s || '').trim()).filter(Boolean).join(' ');

  return {
    // Sol taraf marka ismi (logo yerine metin) — ilk satır büyük + 2 alt satır
    brand: {
      isim: company.name || '',   // büyük ilk satır (örn. "Nef")
      satir1: '',                 // alt satır 1 (manuel — örn. "AYDINLATMA & ENERJİ")
      satir2: '',                 // alt satır 2 (manuel)
    },
    firma: {
      firmaAdi: company.name || '',
      // Hesapta ayrı "tam ad" alanı yok — varsa fullName, yoksa boş (kullanıcı doldurur).
      firmaTamAdi: company.fullName || '',
      adres,
      tel: company.phone || '',
      vergiDairesi: company.taxOffice || '',
      vergiNo: company.taxNo || '',
    },
    sorumlu: {
      adiSoyadi: author.fullName || '',
      unvan: author.title || '',
      odaNo: author.chamberNo || '',       // EMO sicil (Oda No)
      tcNo: author.vergiNo || '',
      gsm: author.phone || '',
      diplomaNo: author.diplomaNo || '',
      vergiSicilNo: author.buroTescilNo || '', // Büro tescil (Vergi Sicil No)
      vergiDairesi: author.vergiDairesi || '',
    },
  };
}

/** Hesapta hiç firma/sorumlu bilgisi girilmiş mi (Marka için) — boşsa Ayarlar'a yönlendirmek için. */
export function hasAnyFirmaInfo() {
  const { firma, sorumlu } = getFirmaInfo();
  return Object.values(firma).some(Boolean) || Object.values(sorumlu).some(Boolean);
}

/** Boş marka veri modeli (CAD Oluşturucu formu başlangıcı). */
export function emptyMarkaData() {
  return {
    brand: { isim: '', satir1: '', satir2: '' },
    firma: { firmaAdi: '', firmaTamAdi: '', adres: '', tel: '', vergiDairesi: '', vergiNo: '' },
    sorumlu: { adiSoyadi: '', unvan: '', odaNo: '', tcNo: '', gsm: '', diplomaNo: '' },
  };
}
